// export const imgUrl = "https://africanbbqapi.devssh.xyz";
// export const imgUrl = "https://afrikanbbq.devssh.xyz";
export const imgUrl = "https://api.afrikanbbq.com";